module.exports = __webpack_public_path__ + "static/img/mode4.0a61ba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/mode4.png
// module id = 7KKu
// module chunks = 1